import { createGlobalStyle } from "styled-components";
import { MENU_NAV_HEIGHT } from "utils/constants";

export const spacing = {
  extraSmall: 5,
  small: 10,
  medium: 16,
  large: 32,
  extraLarge: 40,
} as const;

export type Spacing = typeof spacing[keyof typeof spacing];

const GlobalStyles = createGlobalStyle`
${({ theme }) => `
  :root {
    font-size: 18px;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: ${theme.typography.fontFamilies.sourceSansPro};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: ${theme.typography.fontWeights.regular};
    margin: 0;
    padding: 0;
  }

  p,
  span {
    margin: 0;
    padding: 0;
  }

  a {
    color: inherit;
    font-family: inherit;
    text-decoration: none;
  }

  .mt-xs {
    margin-top: ${spacing.extraSmall}px;
  }

  .mt-sm {
    margin-top: ${spacing.small}px;
  }

  .mt-md {
    margin-top: ${spacing.medium}px;
  }

  .mt-lg {
    margin-top: ${spacing.large}px;
  }

  .mt-xl {
    margin-top: ${spacing.extraLarge}px;
  }

  .mr-sm {
    margin-right: ${spacing.small}px;
  }

  .mr-lg {
    margin-right: ${spacing.large}px;
  }

  .mr-xs {
    margin-right: ${spacing.extraSmall}px;
  }

  .mb-sm {
    margin-bottom: ${spacing.small}px;
  }

  .mb-lg {
    margin-bottom: ${spacing.large}px;
  }

  .ml-sm {
    margin-left: ${spacing.small}px;
  }

  .ml-md {
    margin-left: ${spacing.medium}px;
  }

  .ml-lg {
    margin-left: ${spacing.large}px;
  }

  .anchor-offset {
    scroll-margin-top: ${MENU_NAV_HEIGHT}px;
  }
`}`;

export default GlobalStyles;
